export const PrivacyPolicyPage: React.FC = () => (
  <embed
    src={process.env.PUBLIC_URL + '/GOP-0-GDPR-202404.pdf'}
    type="application/pdf"
    width="100%"
    height="100%"
  />
);
